module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'op--modal-container': true, hide: !_vm.show
    }
  }, [_c('div', {
    staticClass: "op--modal"
  }, [_c('div', {
    staticClass: "op--modal-content"
  }, [_c('div', {
    staticClass: "update-reservation small-margin-v-s"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.updating),
      expression: "!updating"
    }]
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.confirmUpdate')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message !== ''),
      expression: "message !== ''"
    }],
    staticClass: "message margin-b-s",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message margin-b-m"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.updateRsvp2')))]), _vm._v(" "), _c('a', {
    staticClass: "op-btn btn-lg btn-block btn-success",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.yesUpdate')))]), _vm._v(" "), _c('a', {
    staticClass: "cancel-btn margin-t-s",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.noCancel')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.updating),
      expression: "updating"
    }],
    staticClass: "loaderx"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.done),
      expression: "!done"
    }]
  }, [_c('i', {
    staticClass: "fa fa-2x fa-circle-notch fa-spin"
  }), _vm._v(" "), _c('div', {
    staticClass: "margin-t-xs"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.updatingRsvpp')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.success),
      expression: "success"
    }]
  }, [_c('i', {
    staticClass: "fa fa-3x fa-check-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "margin-t-xs"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.successUpdate')))]), _vm._v(" "), _c('a', {
    staticClass: "cancel-btn margin-t-xs",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closeEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.okUpdate')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.success),
      expression: "!success"
    }]
  }, [_c('i', {
    staticClass: "fa fa-3x fa-times-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "margin-t-xs"
  }, [_vm._v(_vm._s(_vm.errorLabel.message))]), _vm._v(" "), _c('a', {
    staticClass: "cancel-btn margin-t-xs",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.errorLabel.button))])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-699b374a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-699b374a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RsvpEdit/UpdateReservation.vue
// module id = 2106
// module chunks = 0